// 转发平台相关

import { downloadUserProgress } from '@/api/modules/download.js';
const actions = {
    getAllUserProgress({ commit }) {
        return new Promise((resolve, reject) => {
            downloadUserProgress().then(
                res => {
                    if (!res) return;
                    commit('SET_USER_ID', res.result || []);
                    resolve(res.result || []);
                },
                error => {
                    reject(error);
                }
            );
        });
    }
};
const mutations = {
    SET_USER_ID: (state, ids) => {
        // console.log(ids);
        state.listids = ids;
    }
};
const state = {
    listids: []
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
